// extracted by mini-css-extract-plugin
module.exports = {"articleCard":"articleCard_articleCard__mAWBX","icon":"articleCard_icon__QmbRR","heading":"articleCard_heading__HwCbM","paragraph":"articleCard_paragraph__vyqKG"};